var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mbo-hero"},[(_vm.hero && _vm.hero.avatar && !_vm.broken)?_c('img',{attrs:{"src":_vm.hero.avatar,"alt":""},on:{"error":function($event){_vm.broken = true}}}):_c('span',{staticClass:"mbo-hero__ph"},[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }